import { toOurProductsPage } from '@/feature/product/services/product.routing'
import { collapseDoubleSlashes, ensureLeadingSlash } from '@/lib/utils/link-utils'

/**
 * Builds the full URL for a universe or category page within "Our Products".
 *
 * @param slug - The universe or category slug.
 * @param stripLeadingSlash - If true, removes the leading slash from the returned URL.
 * @returns The formatted URL.
 */
export function toProductListCategoryOrUniversePage(
  slug: string,
  stripLeadingSlash?: boolean,
): string {
  const base = toOurProductsPage()
  const formattedSlug = ensureLeadingSlash(slug)

  // If already in the correct namespace, return as is
  let fullUrl =
    formattedSlug === base || formattedSlug.startsWith(`${base}/`)
      ? formattedSlug
      : `${base}${formattedSlug}`

  // Optionally remove the leading slash
  if (stripLeadingSlash && fullUrl.startsWith('/')) {
    fullUrl = fullUrl.slice(1)
  }

  return collapseDoubleSlashes(fullUrl)
}

/**
 * Go to the search category page.
 */
export function toSearchCategoryPage(code: string): string {
  return `/search-category/${code}`
}
